import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconReduceMotion: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="reduce-motion"><circle cx="15" cy="12" r="7.25" stroke="currentColor" strokeWidth="1.5"/><circle cx="9" cy="12" r="7.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="0.01 2.5"/></CentralIconBase>;
};

export default IconReduceMotion;
